import React,  { Component }  from 'react';
import { Container } from 'reactstrap';
import './../App.css';
import Navigation from './Navigation';
import NavMenu from './NavMenu';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUserClock, faEdit, faPlus, faSort, faEye, faSlidersH, faSearch, faTimes, faExclamationTriangle, faBars } from '@fortawesome/free-solid-svg-icons';
library.add(faUserClock, faEdit, faPlus, faSort, faEye, faSlidersH, faSearch, faTimes, faExclamationTriangle, faBars);

export default class Layout extends Component {
  constructor(props) {
      super(props);
      this.state = {
          isOpen: false
      };
    }

    getData(val){
      // do not forget to bind getData in constructor
      this.setState({
        isOpen: val
    });
  }

    render() {
      const route = this.props.route;
      const Component = this.props.component;
      return (
          <div>
            <NavMenu />
            <Navigation sendData={this.getData.bind(this)} />
            <div className={!this.state.isOpen ? "menu-color-overlap" : "d-none"}>     
            <Container>
                <Component route={route}/>
            </Container>
            </div>
          </div>
      );
  }
}